import React, { useMemo, useState } from 'react';
import {
  Form,
  Row,
  Col,
} from 'antd';

import {
  useQuery,
  useMutation,
} from '@apollo/client';
import UploadCard from 'components/cards/UploadCard';

import BUSINESS from '../../graphql/business.gql';
import SAVE_BUSINESS from '../../graphql/saveBusiness.gql';
import GET_MY_FLOW from '../../graphql/getMyFlow.gql';

const { Item } = Form;

const BusinessDocuments = ({
  loanId,
  businessId,
  loading: parentLoading,
}) => {
  const [raisPersonFile, setRaisPersonFile] = useState({});
  const [cndScEnvironmentalCrimesFile, setCndScEnvironmentalCrimes] = useState({});

  const {
    data: {
      business,
    } = {},
    refetch,
  } = useQuery(BUSINESS, {
    variables: {
      id: businessId,
    },
    skip: !businessId,
    fetchPolicy: 'cache-only',
    onCompleted: ({ business }) => {
      const additionalFiles = [...business.additionalFiles ?? []];

      additionalFiles
        ?.reverse()
        ?.forEach((file) => {
          if (
            file.parent?.name === 'raisPerson'
          && file.id !== raisPersonFile.id
          ) {
            setRaisPersonFile(file);
          }

          if (
            file.parent?.name === 'cndScEnvironmentalCrimes'
          && file.id !== cndScEnvironmentalCrimesFile.id
          ) {
            setCndScEnvironmentalCrimes(file);
          }
        });
    },
  });

  const {
    data: {
      getMyFlow: {
        businessDocuments = [],
      } = {},
    } = {},
  } = useQuery(GET_MY_FLOW, {
    variables: {
      loanId,
    },
    skip: !loanId,
  });

  const [saveBusiness] = useMutation(SAVE_BUSINESS, {
    onCompleted: () => {
      refetch();
    },
  });

  console.log('businessDocuments', businessDocuments);

  const additionalFiles = useMemo(() => {
    const files = {};

    const additionalFiles = business?.additionalFiles ?? [];
    additionalFiles.forEach((file) => {
      const parentName = file.parent?.name;

      if (!parentName) return;

      if (files[parentName]) {
        if (Array.isArray(files[parentName])) {
          files[parentName].push(file);
        } else {
          files[parentName] = [files[parentName], file];
        }
      } else {
        files[parentName] = file;
      }

    });

    return files;
  }, [business]);

  const documents = useMemo(() => businessDocuments.map((document) => ({
    ...document,
    file: additionalFiles[document.documentValue],
  })), [businessDocuments, additionalFiles]);

  const loading = parentLoading || !business;

  return (
    <Form>
      <Row gutter={12}>
        <Col xs={24} sm={24}>
          <Item
            name="bylawsFileId"
          >
            <UploadCard
              id="bylaws-upload"
              accept="image/png,image/jpeg,application/pdf"
              loading={loading}
              label="Certificado MEI ou Requerimento de empresário ou Contrato Social"
              actualFile={business?.bylaws}
              onCompleted={({ id: bylawsFileId }) => saveBusiness({
                variables: {
                  id: business.id,
                  bylawsFileId,
                },
              })}
            />
          </Item>
        </Col>

        <Col xs={24} sm={24}>
          <Item
            name="proofOfAddressFileId"
          >
            <UploadCard
              id="proof-of-address-upload"
              accept="image/png,image/jpeg,application/pdf"
              loading={loading}
              label="Comprovante de endereço"
              actualFile={business?.address?.proofOfAddress}
              onCompleted={({ id: proofOfAddressFileId }) => saveBusiness({
                variables: {
                  id: business.id,
                  proofOfAddressFileId,
                },
              })}
            />
          </Item>
        </Col>

        {documents.map(({
          documentValue: value, label: name, file, multiple,
        }) => (
          <Col xs={24} sm={24} key={value}>
            <Item
              name={value}
              rules={[{ required: true, message: `Por favor, insira o ${name}` }]}
            >
              <UploadCard
                id="bylaws-upload"
                accept="image/png,image/jpeg,application/pdf"
                loading={loading}
                label={name}
                actualFile={file}
                onCompleted={async ({ id: fileId }) => {
                  const variables = {
                    id: business.id,
                  };
                  variables[value] = fileId;

                  saveBusiness({ variables });
                }}
                multiples={multiple}
              />
            </Item>
          </Col>
        ))}

      </Row>
    </Form>
  );
};

export default BusinessDocuments;
